module.exports = __webpack_public_path__ + "assets/img/eeaf-lv.svg";